import React from "react";
import { toast } from "react-toastify";
import { apiUrl } from "../../Constants/Constants";

export const accountRenewBatchLogic = (
  { fetchWithToken, getInfo, onLogout, closeFinalModal, loadingShow, loading },
  modalContext
) => {
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = modalContext;

  const paybatchRenewPay = (selectedAccounts, amount, discountCode) => {
    console.log(discountCode);
    openUpModal();
    confirmTitle("تایید پرداخت");
    let texter = (
      <>
        آیا مطمئن هستید که می‌خواهید مبلغ
        <strong style={{ padding: "5px", display: "inline-block" }}>
          {amount.toLocaleString("fa-IR")} تومان
        </strong>
        را از کیف پول خود پرداخت کنید ؟
      </>
    );
    description(texter);
    toDo(() => payWithWalletOnRen);
    payloadConfirm([selectedAccounts, discountCode]);
  };

  const payWithWalletOnRen = (accounts) => {
    const former = new FormData();
    loadingShow(true);

    former.append("selectedAccounts", accounts[0]);
    former.append("discountCode", accounts[1] ? accounts[1] : "EMPTY");
    fetchWithToken(
      apiUrl + "user/pay-renew-wallet",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        toast.success("با موفقیت پرداخت گردید.");
        window.location.replace("/");
        loadingShow(false);
      }

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  const fetchPaymentUrl = (selectedAccounts, discountCode) => {
    loadingShow(true);
    const former = new FormData();
    former.append("selectedAccounts", selectedAccounts);
    former.append("discountCode", discountCode ? discountCode : "EMPTY");
    fetchWithToken(
      apiUrl + "user/create-payment",
      {
        method: "POST",
      },
      former
    ).then((data) => {
      if (data.status === "200") {
        toast.info("در حال انتقال به دروازه پرداخت...");
        window.location.replace(data.data);
        // loadingShow(true);
      } else {
        toast.error("دروازه پرداخت ایجاد نشد!");
        loadingShow(false);
      }

      if (data.status === "401") {
        onLogout();
      }
    });
  };

  return {
    fetchPaymentUrl,
    paybatchRenewPay,
  };
};
